import { useCallback, useEffect, useState } from 'react';
import { fetchLiquidacionesBe, LiquidacionBePeriodo } from './api/liquidaciones';

/**
 * Historial de liquidaciones ya migrado a psiplatform-be (GET /psychologist/liquidaciones).
 * Fuente nueva y todavía incompleta a propósito: arranca vacía y se completa hacia
 * adelante a medida que psima informa cada período — por eso los fallos acá son
 * silenciosos (sin toast, sin pantalla de error propia): el webhook de Make sigue
 * siendo la fuente que nunca falta mientras esta tabla se completa (ver
 * MetricsLiquidacionTab.tsx, mergeLiquidacionPeriodos).
 */
export function useLiquidacionesBe() {
  const [periodos, setPeriodos] = useState<LiquidacionBePeriodo[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const load = useCallback(() => {
    setIsLoading(true);
    fetchLiquidacionesBe()
      .then((resp) => setPeriodos(resp.periodos))
      .catch(() => setPeriodos([]))
      .finally(() => setIsLoading(false));
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return { periodos, isLoading, refetch: load };
}
